import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { ApiError } from '../../lib/api-client';
import { ServerErrorState } from './SystemState';

/**
 * SYS-05 for a page that couldn't load at all — the session check or a route's data failed, say because the
 * database was down. Our own state with Try again and the request id, never the router's bare default.
 */
export function RouteErrorState({ error, reset }: ErrorComponentProps): ReactNode {
  const router = useRouter();
  return (
    <ServerErrorState
      requestId={error instanceof ApiError ? error.requestId : undefined}
      onRetry={() => {
        reset();
        void router.invalidate();
      }}
    />
  );
}
